<ng-container *ngIf="editDraftForm && draft">
  <form [formGroup]="editDraftForm">
    <div class="form-check">
      <div class="toggles">
        <label for="isPrivate">
          {{'BUTTON.DRAFT_IS_PRIVATE' | translate}}
          <input type="checkbox" id="isPrivate"
                 [formControl]="editDraftForm.get('isPrivate')"
                 [checked]="editDraftForm.get('isPrivate').value === true"
                 [ngClass]="{'is-invalid': !editDraftForm.get('isPrivate').valid && editDraftForm.get('isPrivate').dirty}">
          <span class="lever"></span>
        </label>
      </div>
    </div>
    <div class="form-check" *ngIf="!checkSameOperator(draft)">
      <div class="toggles">
        <label for="changeOperator">
          {{'BUTTON.CHANGE_OPERATOR' | translate}}
          <input type="checkbox" id="changeOperator"
                 [formControl]="editDraftForm.get('changeOperator')"
                 [checked]="editDraftForm.get('changeOperator').value === true"
                 [ngClass]="{'is-invalid': !editDraftForm.get('changeOperator').valid && editDraftForm.get('changeOperator').dirty}">
          <span class="lever"></span>
        </label>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col">
        <label for="draft">{{'DRAFT_NAME' | translate}}</label>
        <input type="text" class="form-control" id="draft"
               [formControl]="editDraftForm.get('draft')"
               [ngClass]="{'is-invalid': !editDraftForm.get('draft').valid && editDraftForm.get('draft').dirty}">
        <app-error-label [control]="editDraftForm.get('draft')"
                         [errors]="formErrors['draft']"></app-error-label>
      </div>
    </div>
  </form>
</ng-container>
